export default __webpack_public_path__ + "static/media/error404.0077ec9a.png";